"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var ActivationLogoutButton = (0, styles_1.styled)(TextButton_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(0.25, 2.25),
        fontSize: theme.typography.body1.fontSize,
        fontWeight: theme.typography.fontWeightMedium,
        borderRadius: 5,
        position: 'absolute',
        top: 42,
        right: 24,
        color: 'rgba(255, 255, 255, 0.65)',
        '&:hover': {
            color: theme.palette.common.white,
            background: 'rgba(255, 255, 255, 0.5)',
            textDecoration: 'none',
        },
        '&[disabled]': {
            color: 'rgba(255, 255, 255, 0.35)',
            pointerEvents: 'none',
        },
        '&:active': {
            backgroundColor: 'rgba(255, 255, 255, 0.35)',
            color: theme.palette.common.white,
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(ActivationLogoutButton, {
    size: 'small',
    color: 'inherit',
});
